import { FormBeforeSendError } from './FormBeforeSendError';

export class FormBeforeSendValidationError extends FormBeforeSendError {
  constructor(message = 'One or more fields are invalid') {
    super(message);

    this.code = 'validation_error';
  }
}
